import { v2 } from "../api/v2";

export const resetSessionVariables = () => {
	let referenceCode = localStorage.getItem("referenceCode");
	// Handle the response from the server
	localStorage.setItem("isAuthenticated", "");
	localStorage.setItem("patientDetails", "");
	localStorage.setItem("authToken", null);
	window.location.href = "/home/" + referenceCode;
}

const LogOutService = {
	logOut: function () {
		// v2: DELETE /v1/public/patient/logout (best-effort, stateless JWT).
		// Always clear the client session afterwards.
		return v2.logout(localStorage.getItem("referenceCode") || undefined).then(() => {
			resetSessionVariables();
		});
	},
};

export default LogOutService;
